import { useI18n } from "@/lib/i18n/i18n_provider";
import { useEffect } from "react";

export function useDynamicPartnerConfigLocale(partnerSlug: string) {
  const { onAddToDictionary } = useI18n();

  useEffect(() => {
    // Take note that moving the files or changing the file name will break this code
    import(`../../offering/${partnerSlug}/${partnerSlug}_locale_en.ts`)
      .then((module) => {
        const dictionary = module.default;
        onAddToDictionary({ en: dictionary, "en-US": dictionary });
      })
      .catch(() => {
        // if file does not exists do nothing
      });
  }, [partnerSlug, onAddToDictionary]);
}
